import React from "react";

const VideoCard = ({ info }) => {
  // console.log("info", info);

  if (!info) return null;
  const { snippet, statistics } = info;
  const { channelTitle, thumbnails, title } = snippet;
  /// const {viewCount} = statastics;
  return (
    <div>
      <div className=" p-2 w-96 cursor-pointer">
        <img className="rounded-lg w-full" src={thumbnails.medium.url} alt="" />
        <div className="flex ">
          <img className="w-9 h-9 m-2 rounded-full object-cover " src={thumbnails.medium.url} alt="channelIcon" />{" "}
          <ul>
            <li className="font-semibold	 pt-2 line-clamp-2">{title}</li>
            <li>{channelTitle}</li>
            {/* <li>{Math.round(statistics.viewCount / 1000)}k views</li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
